import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CheckboxChecked = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <rect width="16" height="16" rx="2" fill={color} />
        <path
          d="M4 8.41176C4.79279 8.96078 6.37838 10.4706 7.02703 11.5C7.81982 9.85294 9.83784 6.14706 12 4.5"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

export default CheckboxChecked
